export const defaultFilters = {
  currency: "",
  minPrice: null,
  maxPrice: null,
  minRooms: null,  // Nuevo campo
  maxRooms: null,  // Nuevo campo
  minBedrooms: null,  // Nuevo campo
  maxBedrooms: null,  // Nuevo campo
  minBathrooms: null, // Nuevo campo
  maxBathrooms: null, // Nuevo campo
  minSquareMetersCovered: 0,
  maxSquareMetersCovered: 0,
  minSquareMetersTotal: 0,
  maxSquareMetersTotal: 0,
  expenses: 0,
  garage: false,
  hasPool: false,
  hasGrill: false,
  hasGarden: false,
  hasTerrace: false,
  hasBalcony: false,
  daysPublished: "",
  ownerType: "",
  transactionType: [],
  typeProperty: [],
  radius: null,
  center: null,
  minRooms: null,     // Nuevo: Ambientes mínimos
  maxRooms: null,     // Nuevo: Ambientes máximos
  minAntiquity: null, // Cambio importante
  maxAntiquity: null,
  ownerType: "",
};

export const resetFiltersValues = {
  currency: "",
  minPrice: 0,
  maxPrice: 30000000,
  minBedrooms: null,
  maxBedrooms: null,
  minBathrooms: null,
  maxBathrooms: null,
  minSquareMetersCovered: 0,
  maxSquareMetersCovered: 0,
  minSquareMetersTotal: 0,
  maxSquareMetersTotal: 0,
  expenses: 0,
  garage: false,
  hasPool: false,
  hasGrill: false,
  hasGarden: false,
  hasTerrace: false,
  hasBacony: false,
  daysPublished: "",
  transactionType: [],
  typeProperty: [],
  radius: null,
  center: null,
  minRooms: null,
  maxRooms: null,
  minAntiquity: null,
  maxAntiquity: null,
  ownerType: "",
};
export const typePropertyOptions = [
  { label: "Quintas Vacacionales",          value: "quintas-vacacionales" },
  { label: "Campos",                        value: "campos" },
  { label: "Bóvedas, Nichos y Parcelas",    value: "bovedas-nichos-y-parcelas" },
  { label: "Terrenos",                      value: "terrenos" },
  { label: "Cocheras",                      value: "cocheras" },
  { label: "Desarrollos Horizontales",      value: "desarrollos-horizontales" },
  { label: "Desarrollos Verticales",        value: "desarrollos-verticales" },
  { label: "Hoteles",                       value: "hoteles" },
  { label: "Oficinas Comerciales",          value: "oficinas-comerciales" },
  { label: "Depósitos",                     value: "depositos" },
  { label: "Locales Comerciales",           value: "locales-comerciales" },
  { label: "Edificios",                     value: "edificios" },
  { label: "Bodegas/Galpónes",              value: "bodegas-galpones" },
  { label: "Fondos de Comercio",            value: "fondos-de-comercio" },
  { label: "Casa",                          value: "casas" },
  { label: "Departamento",                  value: "departamentos" },
  { label: "Oficina",                       value: "oficinas" },
  { label: "Consultorio",                   value: "consultorios" },
  { label: "PH",                            value: "ph" },
];

export const ownerTypeOptions = [
  { label: "Directo", value: "directo" },
  { label: "Inmobiliaria", value: "inmobiliaria" },
];
export const handleTempFilterChange = (setTempFilters, name, value) => {
  if (name === "currency") {
    setTempFilters((prev) => ({
      ...prev,
      [name]: value,
      minPrice: 0,
      maxPrice: value === "USD" ? 1000000 : 300000000,
    }));
  } else {
    setTempFilters((prev) => ({ ...prev, [name]: value }));
  }
};

export const applyFilters = (setFilters, tempFilters, setShowAdvancedFilters) => {
  setFilters(tempFilters);
  setShowAdvancedFilters(false);
};

export const resetFilters = (setTempFilters, setFilters, setShowAdvancedFilters, resetFiltersValues) => {
  setTempFilters(resetFiltersValues);
  setFilters(resetFiltersValues);
  setShowAdvancedFilters(true);
};